import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\">\r\n    <path d=\"M10.38,23.676 C6.912,19.38 2.832,16.128 0,15.108 L6.72,11.076 L9.96,17.376 C9.96,17.376 15.24,4.584 23.58,0.324 C23.4,3.372 22.572,6.012 24,9.264 C20.34,10.092 12.828,19.224 10.38,23.676 Z\" id=\"icon-right_路径\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol